import React from 'react'
import { ProgressBar } from 'react-bootstrap'
import { humanReadableByteCount, stripProtocol } from './../../lib/helper'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

class WPCOMStats extends React.Component {
	render() {
		const { migrate, cancel, progress } = this.props
		return <div className="wpcom">
			<main className="wpcom-migration-content-full-width">
				<div className="wpcom-migration-content-header">
					<div className="wpcom-migration-content-header__blogvault_logo">
						<img src="/assets/migration/wpcom-bv-logo.png" alt="blogvault-logo" />
					</div>
					<p className="wpcom-migration-content-header-site">
						We&apos;re migrating <strong>{stripProtocol(migrate.get('source_site'))}</strong> to WordPress.com
					</p>
				</div>
				<div className="wpcom-migration-container-full-width">
					<div className="font-13">
						Watch the progress or take a break — your migration will not be disrupted if you close this window. We&apos;ll reach out to you at <strong>{migrate.get('email')}</strong> when it&apos;s done!
					</div>
					<div className="wpcom-migration-progress">
						<div className="wpcom-migration-progress-row">
							<div className="wpcom-migration-progress-section">
								<div>
									<p className="wpcom-migration-progress-header">
										{humanReadableByteCount(migrate.getIn(['status', 'files', 'size', 'synced']))}/
										{humanReadableByteCount(migrate.getIn(['status', 'files', 'size', 'total']) - migrate.getIn(['status', 'files', 'size', 'ignored']))}
										&nbsp;synced
									</p>
								</div>
								<div>
									<div className="wpcom-migration-progress-bar">
										<ProgressBar now={migrate.getIn(['status', 'files_progress'])} className="wpcom-migration-progress-bar-progress"/>
									</div>
								</div>
							</div>
							<div className="wpcom-migration-progress-section">
								<div>
									<p className="wpcom-migration-progress-header">
										{migrate.getIn(['status', 'database', 'synced'])}/
										{migrate.getIn(['status', 'database', 'total']) - migrate.getIn(['status', 'database', 'ignored'])}
										&nbsp;tables
									</p>
								</div>
								<div>
									<div className="wpcom-migration-progress-bar">
										<ProgressBar bsStyle="success" now={migrate.getIn(['status', 'tables_progress'])} className="wpcom-migration-progress-bar-progress"/>
									</div>
								</div>
							</div>
						</div>
						<div className="wpcom-migration-progress-section">
							<div>
								<p className="wpcom-migration-progress-header">Migrating site ({progress}%)</p>
							</div>
							<div>
								<div className="wpcom-migration-progress-bar">
									<ProgressBar bsStyle="info" now={progress} className="wpcom-migration-progress-bar-progress"/>
								</div>
							</div>
						</div>
					</div>
					<div className="wpcom-migration-form">
						<button className="secondary" onClick={cancel}>
							Cancel migration
						</button>
					</div>
				</div>
			</main>
		</div>
	}
}

WPCOMStats.propTypes = {
	migrate: ImmutablePropTypes.map,
	cancel: PropTypes.func,
	progress: PropTypes.number
}

export default WPCOMStats
